import script from "./B2BSchedulePage.vue?vue&type=script&setup=true&lang=js"
export * from "./B2BSchedulePage.vue?vue&type=script&setup=true&lang=js"

import "./B2BSchedulePage.vue?vue&type=style&index=0&id=5dc7a9eb&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc7a9eb"]])

export default __exports__